<template>
  <div class="erro-inicializacao">
    <v-icon size="120">error_outline</v-icon>
    <h1>Ocorreu um erro na inicialização desta aplicação</h1>
    <h2 class="red--text pt-2">{{mensagemErro}}</h2>
  </div>
</template>
<script>

export default {
  props: ['mensagemErro'],
}
</script>

<style lang="stylus">
.erro-inicializacao
  text-align center
  padding-top 10%
  padding-bottom 20%
  font-family 'Roboto', sans-serif
</style>
